<template>
  <div>
    <qtm-chip color="interactive-lighten-1" text-color="secondary">
      {{ dateYear(date) }}
    </qtm-chip>
    <div class="my-2 qtm-h4" v-text="title" />
    <div v-for="(section, i) in sections" :key="i" class="mb-4">
      <safe-html class="qtm-body text-mid-dark-grey" :html="section.content ?? ''" />
      <div v-if="section.images" class="d-flex mt-4 images">
        <v-img v-for="image in section.images" :key="image" :src="image" />
      </div>
    </div>
    <div v-if="link" class="mt-4">
      <nuxt-link class="qtm-label text-decoration-none" :to="link.to" @click="$emit('click')">
        {{ link.text }}
      </nuxt-link>
    </div>
    <div v-if="!noMobile" class="mt-4">
      Scan to update QuoteToMe mobile app:
      <div>
        <v-img src="/qr/apple.png" style="margin-left: 11px" width="115" />
      </div>
      <div>
        <v-img src="/qr/android.png" width="144" />
      </div>
    </div>
    <v-divider class="my-4" />
  </div>
</template>

<script setup lang="ts">
import type { DateTime } from '@quotetome/materials-api'
import { dateYear } from '@/models/filters'

export interface Props {
  date: DateTime
  link?: { text: string, to: Record<string, any> }
  noMobile?: boolean
  sections: {
    content?: string
    images?: string[]
  }[]
  title: string
}

defineProps<Props>()
defineEmits(['click'])
</script>

<style lang="scss" scoped>
.images > *:not(:first-child) {
  margin-left: 16px;
}
</style>
